// NATIVE 
import { useEffect, useState } from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CardUserSystemDetails } from '../../components/generics/CardUserSystemDetails';


// CUSTOM 
import { IUserPermissions } from '../../commons/interfaces';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { DetailUserSystemPermissions } from '../../components/generics/DetailUserSystemPermissions';



/**
 * DetailUsuarioPermissions component displays the details of a user's permissions.
 * 
 * This component fetches user permissions from the Redux store and displays them
 * using the CardUserSystemDetails and DetailUserSystemPermissions components.
 * 
 * If no user permissions are found, it navigates back to the user permissions list page.
 * 
 * @component
 * @example
 * return (
 *   <DetailUsuarioPermissions />
 * )
 * 
 * @returns {JSX.Element} The rendered component.
 */
export const DetailUsuarioPermissions = () => {

 
  // USE NAVIGATE 
  const navigate = useNavigate();


  // USE SELECTOR 
  const { user_permissions }:any  = useSelector( (state:any) => state.usersPermissions );


  // USE STATE 
  const [userPermissions, setUserPermissions] = useState<IUserPermissions>({
    id: 'Cargando...',
    name: 'Cargando...',
    email: 'Cargando...',
    avatar: 'Cargando...',
    status: 'Cargando...',
    permissions: []
  });



  // USE EFFECT 
  useEffect(() => {     

    if ( !user_permissions || Object.keys(user_permissions).length == 0 ) {
          navigate("/manager/usuarios-permisos");
    }

  }, []);

  useEffect(() => {
    setUserPermissions(user_permissions);
  }, [user_permissions]);
  

   

  return (
    <>

      
      <BreadCrumbsAndTitle 
              title="Detalle Usuario Permisos" 
              mainModule="configuracion" 
              parent="Listar Usuarios Permisos"
              action="/manager/usuarios-permisos" />

      <Grid container spacing={2}> 

        {/* INICIO LADO A */} 
        <Grid item xs={3}> 
           <CardUserSystemDetails {...userPermissions} />
        </Grid>
        {/* FIN LADO A  */}


        {/* INICIO LADO B */} 
        <Grid item xs={9}> 
           <DetailUserSystemPermissions {...userPermissions} />
        </Grid>
        {/* FIN LADO B  */}

      </Grid>

      
    </>
  )
}
